/**
 * PlayFromStartIcon — "From start" (spec 009): a bar, then a play triangle.
 * Used by the scene editor toolbar, PreviewTransport and the timeline transport.
 */
import React from 'react';

const PlayFromStartIcon: React.FC<{ size?: number }> = ({ size = 18 }) => (
  <svg width={(size * 20) / 18} height={size} viewBox="0 0 20 18" fill="currentColor" aria-hidden="true">
    <rect x="1" y="2" width="4.5" height="14" rx="2.25" />
    <path d="M8.5 3.2v11.6a1.2 1.2 0 0 0 1.8 1l9-5.8a1.2 1.2 0 0 0 0-2l-9-5.8a1.2 1.2 0 0 0-1.8 1z" />
  </svg>
);

export default PlayFromStartIcon;
